let index = {
  game: "/management/sportcenter/game",
  traincamp: "/management/sportcenter/traincamp",
  campus: "/management/sportcenter/campus",
  club: "/management/sportcenter/club",
  updatepwd: "/management/sportcenter/updatepwd",
  record: "/management/sportcenter/record"
};
export default [
  /**U系列比赛 */
  {
    path: "sportcenter/game",
    component: () => import(/* webpackChunkName: "sportcenter_game" */ "@/views/sportcenter/management/game/Main.vue"),
    meta: { index: index.game },
    children: [
      {
        path: "",
        name: "sportcenter_game_list",
        component: () =>
          import(/* webpackChunkName: "sportcenter_game_list" */ "@/views/sportcenter/management/game/Index.vue"),
        meta: { index: index.game }
      },
      {
        path: ":id",
        name: "sportcenter_game_list_editGame",
        component: () => import(/* webpackChunkName: "editGame" */ "@/views/sportcenter/management/game/EditGame.vue"),
        meta: { index: index.game }
      },
      {
        path: "new",
        name: "sportcenter_game_list_addGame",
        component: () => import(/* webpackChunkName: "editGame" */ "@/views/sportcenter/management/game/EditGame.vue"),
        meta: { index: index.game }
      }
    ]
  },
  /**训练营 */
  {
    path: "sportcenter/traincamp",
    component: () =>
      import(/* webpackChunkName: "sportcenter_traincamp" */ "@/views/sportcenter/management/traincamp/Main.vue"),
    meta: { index: index.traincamp },
    children: [
      {
        path: "",
        name: "sportcenter_traincamp_list",
        component: () =>
          import(
            /* webpackChunkName: "sportcenter_traincamp_list" */ "@/views/sportcenter/management/traincamp/Index.vue"
          ),
        meta: { index: index.traincamp }
      },
      {
        path: ":id",
        name: "sportcenter_traincamp_list_editTrainCamp",
        component: () =>
          import(/* webpackChunkName: "editTrainCamp" */ "@/views/sportcenter/management/traincamp/EditTrainCamp.vue"),
        meta: { index: index.traincamp }
      },
      {
        path: "new",
        name: "sportcenter_traincamp_list_addTrainCamp",
        component: () =>
          import(/* webpackChunkName: "editTrainCamp" */ "@/views/sportcenter/management/traincamp/EditTrainCamp.vue"),
        meta: { index: index.traincamp }
      }
    ]
  },
  /**传统校比赛 */
  {
    path: "sportcenter/campus",
    component: () =>
      import(/* webpackChunkName: "sportcenter_campus" */ "@/views/sportcenter/management/campus/Main.vue"),
    meta: { index: index.campus },
    children: [
      {
        path: "",
        name: "sportcenter_campus_list",
        component: () =>
          import(/* webpackChunkName: "sportcenter_campus_list" */ "@/views/sportcenter/management/campus/Index.vue"),
        meta: { index: index.campus }
      },
      {
        path: ":id",
        name: "sportcenter_campus_list_editCampusSchool",
        component: () =>
          import(/* webpackChunkName: "editSchool" */ "@/views/sportcenter/management/campus/EditSchool.vue"),
        meta: { index: index.campus }
      },
      {
        path: "new",
        name: "sportcenter_campus_list_addCampusSchool",
        component: () =>
          import(/* webpackChunkName: "editSchool" */ "@/views/sportcenter/management/campus/EditSchool.vue"),
        meta: { index: index.campus }
      }
    ]
  },
  /**全国青少年体育赛事备案 */
  {
    path: "sportcenter/record",
    component: () =>
      import(/* webpackChunkName: "sportcenter_record" */ "@/views/sportcenter/management/record/Main.vue"),
    meta: { index: index.record },
    children: [
      {
        path: "",
        name: "sportcenter_record_list",
        component: () =>
          import(/* webpackChunkName: "sportcenter_record_list" */ "@/views/sportcenter/management/record/Index.vue"),
        meta: { index: index.record }
      },
      {
        path: ":id",
        name: "sportcenter_record_list_editrecord",
        component: () =>
          import(/* webpackChunkName: "editRecord" */ "@/views/sportcenter/management/record/EditRecord.vue"),
        meta: { index: index.record }
      },
      {
        path: "new",
        name: "sportcenter_record_list_addrecord",
        component: () =>
          import(/* webpackChunkName: "editRecord" */ "@/views/sportcenter/management/record/EditRecord.vue"),
        meta: { index: index.record }
      }
    ]
  },
  /**俱乐部比赛 */
  // {
  //   path: "sportcenter/club",
  //   component: () => import(/* webpackChunkName: "sportcenter_club" */ "@/views/sportcenter/management/club/Main.vue"),
  //   meta: { index: index.club },
  //   children: [
  //     {
  //       path: "",
  //       name: "sportcenter_club_list",
  //       component: () =>
  //         import(/* webpackChunkName: "sportcenter_club_list" */ "@/views/sportcenter/management/club/Index.vue"),
  //       meta: { index: index.club }
  //     },
  //     {
  //       path: ":id",
  //       name: "sportcenter_club_list_editClub",
  //       component: () => import(/* webpackChunkName: "editClub" */ "@/views/sportcenter/management/club/EditClub.vue"),
  //       meta: { index: index.club }
  //     },
  //     {
  //       path: "new",
  //       name: "sportcenter_club_list_addClub",
  //       component: () => import(/* webpackChunkName: "editClub" */ "@/views/sportcenter/management/club/EditClub.vue"),
  //       meta: { index: index.club }
  //     }
  //   ]
  // },
  /**修改密码 */
  {
    path: "sportcenter/updatepwd",
    component: () => import(/* webpackChunkName: "sportcenter_updatepwd" */ "@/views/setting/password/Update.vue"),
    meta: { index: index.updatepwd },
    children: [
      {
        path: "",
        name: "sportcenter_updatepwd_list",
        component: () =>
          import(/* webpackChunkName: "sportcenter_updatepwd_list" */ "@/views/setting/password/Update.vue"),
        meta: { index: index.updatepwd }
      }
    ]
  }
];
